import { config as accordionConfig } from '../dynamic-content-page/content-components/accordion';
import { config as consultationTeaserConfig } from '../dynamic-content-page/content-components/consultation-teaser';
import { config as flexibleContentConfig } from '../dynamic-content-page/content-components/flexible-content';
import { config as heading2CenterConfig } from '../dynamic-content-page/content-components/heading-2-center';
import { config as mewaCircleConfig } from '../dynamic-content-page/content-components/shared-mewa-circle';
import { config as shortTextTeaserConfig } from '../dynamic-content-page/content-components/short-text-teaser';
import { config as spacerConfig } from '../dynamic-content-page/content-components/spacer';
import {
  GenericConfig,
  getGenericSectionConfig,
} from '../dynamic-content-page/fragment-and-types';

export const possibleComponents: GenericConfig[] = [
  getGenericSectionConfig(accordionConfig),
  getGenericSectionConfig(heading2CenterConfig),
  getGenericSectionConfig(shortTextTeaserConfig),
  getGenericSectionConfig(spacerConfig),
  getGenericSectionConfig(consultationTeaserConfig),
  getGenericSectionConfig(mewaCircleConfig),
  getGenericSectionConfig(flexibleContentConfig),
];
